import Qs from 'qs';

// Create a cache object
const cache = new Map<string, { data: any; expiry: number }>();

// Generate a unique cache key based on the URL and parameters
const generateCacheKey = (url: string, params: any): string => {
  return `${url}?${Qs.stringify(params, { arrayFormat: 'brackets' })}`;
};

// Reusable caching mechanism function with TTL
export const withCacheTTL = <T>(
  fetchFunction: (filter: any, headers: any) => Promise<T>,
  url: string,
  ttl = 60000 // Default TTL: 1 minute (60,000 milliseconds)
) => {
  return async (filter: any | null = null, headers = {}): Promise<T> => {
    const cacheKey = generateCacheKey(url, filter);
    // Check if response is in the cache and still valid
    const cachedEntry = cache.get(cacheKey);
    if (cachedEntry) {
      if (cachedEntry.expiry > Date.now()) {
        return Promise.resolve(cachedEntry.data);
      } else {
        // Remove expired entry
        cache.delete(cacheKey);
      }
    }

    // If cache is expired or not found, fetch data
    const response = await fetchFunction(filter, headers);

    // Cache the response with expiry time
    cache.set(cacheKey, { data: response, expiry: Date.now() + ttl });

    return response;
  };
};
